import { useEffect, type ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useHashRoute } from "@/hooks/useHashRoute";
import { Skeleton } from "@/components/ui/skeleton";

const RETURN_KEY = "foundry:returnTo";

export function rememberReturnTo(hash: string) {
  try {
    sessionStorage.setItem(RETURN_KEY, hash);
  } catch {
    /* ignore */
  }
}

export function consumeReturnTo(): string | null {
  try {
    const v = sessionStorage.getItem(RETURN_KEY);
    if (v) sessionStorage.removeItem(RETURN_KEY);
    return v;
  } catch {
    return null;
  }
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { loading, session } = useAuth();
  const { hash, navigate } = useHashRoute();

  useEffect(() => {
    if (loading) return;
    if (!session) {
      rememberReturnTo(hash);
      navigate("#/login");
    }
  }, [loading, session, hash, navigate]);

  if (loading) {
    return (
      <div className="mx-auto mt-16 w-full max-w-sm space-y-3 px-4">
        <Skeleton className="h-8 w-3/4" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }
  if (!session) return null;
  return <>{children}</>;
}
